import React, { useEffect, useRef, useState } from "react";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import { Btn } from "../../../../AbstractElements";

interface LeftListOptionDataInterface {
  id?: string | number;
  label: string | number;
}

interface DualListboxProps {
  LeftListOptionData?: LeftListOptionDataInterface[];
  leftSideitem?: (item: any) => void;
  rightSideitem?: (item: any) => void;
  handleLeftbtn?: () => void;
  handleRightbtn?: () => void;

  handleSearchInputLeft?: (e: any) => void;
  handleSearchInputRight?: (e: any) => void;
  RightListOptionData?: LeftListOptionDataInterface[];
  onReachEnd?: () => void;
  blockObserverRef: React.MutableRefObject<boolean>;
}

const NewDualList: React.FC<DualListboxProps> = ({
  blockObserverRef,
  onReachEnd,
  handleSearchInputRight,
  handleSearchInputLeft,
  handleLeftbtn,
  handleRightbtn,
  LeftListOptionData,
  leftSideitem,
  RightListOptionData,
  rightSideitem,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollableRef = useRef<HTMLDivElement>(null);
  const [text, setText] = useState("");

  useEffect(() => {
    if (!scrollableRef.current || !containerRef.current) return;
    if (text == "") {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            onReachEnd?.();
          }
        },
        {
          threshold: 0.1,
          root: scrollableRef.current,
          rootMargin: "0px 0px 50px 0px",
        }
      );
      observer.observe(containerRef.current);

      return () => {
        observer.disconnect();
      };
    } else {
      blockObserverRef.current = false;
    }
  }, [onReachEnd, text]);

  const handleInputInsdeDualList = (e: any) => {
    const text = e.target.value;
    setText(text);
  };

  return (
    <div
      className="parent"
      style={{
        display: "flex",
        justifyContent: "start",
        padding: "2px",
        // border:'1px solid #888',
        borderRadius: "4px",
      }}
    >
      {/* Left List */}
      <div
        className="LeftChild"
        style={{
          backgroundColor: "transparent",
          height: 216,
          width: 200,
          display: "flex",
          flexDirection: "column",
          border: "1px solid #e0e0e0",
          padding: "5px",
          borderRadius: "4px",
          fontSize: "13px",
        }}
      >
        {/* Scrollable List */}
        <div
          ref={scrollableRef}
          style={{
            overflowY: "scroll",
            flex: 1,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <ul style={{ padding: 0, margin: 0, position: "relative" }}>
            {/* Fixed Search Bar as a list item */}
            <li
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "transparent",
                border: "none",
              }}
            >
              <input
                type="text"
                placeholder="Search..."
                onChange={(e) => {
                  handleSearchInputLeft?.(e);
                  handleInputInsdeDualList(e);
                }}
                style={{
                  width: "100%",
                  height: "30px",
                  border: "none",
                }}
              />
            </li>

            {/* Data List */}
            {LeftListOptionData?.map((item) => (
              <li
                onClick={() => leftSideitem?.(item)}
                key={item.id}
                style={{
                  cursor: "pointer",
                  borderBottom: "0.5px solid #e0e0e0",
                  listStyle: "none",
                  marginBottom: "8px",
                  padding: "4px",
                }}
              >
                {item.label}
              </li>
            ))}
            <div ref={containerRef} style={{ height: 10 }} />
          </ul>
        </div>
      </div>
      {/* mid buttons */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "8px",
          gap: "14px",
          justifyContent: "center",
          padding: "4px",
        }}
      >
        <Btn
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#43B9B2",
            color: "white",
            padding: "5px",
          }}
          disabled={LeftListOptionData?.length === 0}
          onClick={handleLeftbtn}
        >
          <FaLongArrowAltRight />
        </Btn>

        <Btn
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#43B9B2",
            color: "white",
            padding: "5px",
          }}
          disabled={RightListOptionData?.length === 0}
          onClick={handleRightbtn}
        >
          <FaLongArrowAltLeft />
        </Btn>
      </div>
      {/* Right List */}
      <div
        className="RightChild"
        style={{
          backgroundColor: "transparent",
          height: 216,
          width: 200,
          display: "flex",
          flexDirection: "column",
          position: "relative", // Add this
          overflow: "auto", // Add this for scrollable content
          border: "1px solid #e0e0e0",
          padding: "5px",
          borderRadius: "4px",
        }}
      >
        <div
          style={{
            width: "100%", // Ensure full width
          }}
        >
          <ul
            style={{
              padding: 0,
              margin: 0,
            }}
          >
            <li
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "transparent",
                padding: "2px",
                zIndex: 1, // Ensure it stays above other elements
              }}
            >
              <input
                type="text"
                placeholder="Search..."
                onChange={handleSearchInputRight}
                style={{
                  width: "100%",
                  padding: "4px",
                  height: "30px",
                  border: "none",
                }}
              />
            </li>

            {RightListOptionData?.map((item) => (
              <li
                onClick={() => rightSideitem?.(item)}
                key={item.id}
                style={{
                  cursor: "pointer",
                  borderBottom: "2px solid #e0e0e0",
                  listStyle: "none",
                  marginBottom: "8px",
                  padding: "4px",
                  fontSize: "13px",
                  // borderRadius: "4px",
                }}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NewDualList;
